import React from 'react';
import Media from 'react-media';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { string, object, func } from 'prop-types';
import _ from 'lodash';
import Card from '../../../../components/LazyWidgets/Card';
import Spinner from '../../../../components/LazyWidgets/Spinner';
import Button from '../../../../components/LazyWidgets/Button';
import { fetchReflectionSummaryReportData, updateActiveDraftReflectionSummary } from '../../../actions/reports';
import s from './skillsReflectionSummary.module.css';
import ReportError from '../ReportError';
import StackedBarReflection from './components/StackedBarReflection';
import SkillsReflectionDropdown from './components/SkillsReflectionDropdown';
import SkillsReflectionTable from './components/SkillsReflectionTable';
import ReportBreadcrumbs from '../../../../components/ReportBreadcrumbs/ReportBreadcrumbs';
import { withMatch } from '../../../../hoc';

class SkillsReflectionSummary extends React.Component {
  static propTypes = {
    courseId: string,
    skills: object,
    fetchReflectionSummaryReportData: func,
    updateActiveDraftReflectionSummary: func,
    onTabChange: func,
    match: object,
    courseName: string,
    reportTitle: string,
  }
  constructor(props) {
    super(props);

    const tableStyle = [
      {
        row: 'styledRow',
      },
    ];
    this.state = {
      tableStyle,
      studentListCollapsed: true,
    };
    this.containerRef = React.createRef();
    this.dropdownChangeHandler = this.dropdownChangeHandler.bind(this);
    this.buttonClickHandler = this.buttonClickHandler.bind(this);
  }

  async componentDidMount() {
    const draftId = this.getDraftIdFromProps(this.props);
    await this.props.fetchReflectionSummaryReportData(this.props.courseId, this.props.courseName);

    if (draftId) {
      this.changeDraft(draftId);
    } else {
      const {
        reflectionSummary: {
          activeDraft,
        },
      } = this.props.skills;
      this.props.onTabChange(`reports/type/reflections/${activeDraft.id}`);
    }
    this.adjustDropDowns();
  }

  componentDidUpdate(prevProps) {
    const draftId = this.getDraftIdFromProps(this.props);
    const prevDraftId = this.getDraftIdFromProps(prevProps);
    if (draftId !== prevDraftId) {
      this.changeDraft(draftId);
    }
    this.adjustDropDowns();
  }

  getDraftIdFromProps(props) {
    return (props.match.params.itemId) ? props.match.params.itemId.split('#')[0].split('?')[0] : null;
  }

  changeDraft(draftId) {
    const {
      reflectionSummary: {
        activeDraft,
        dropDownObject,
      },
    } = this.props.skills;

    if (dropDownObject) {
      const draft = dropDownObject.find(d => d.id === draftId);
      this.props.updateActiveDraftReflectionSummary(activeDraft, draft, this.props.courseName);
    }
  }

  adjustDropDowns() {
    if (this.containerRef.current) {
      const dropDowns = this.containerRef.current.getElementsByTagName('select');
      for (const dropDown of dropDowns) {
        const dropdownOptionTitle = dropDown.options[dropDown.selectedIndex].textContent;
        const fakeWidth = this.calculateFakeWidth(dropdownOptionTitle);
        if (fakeWidth > dropDown.offsetWidth + 3) {
          dropDown.parentElement.classList.add(s.ellipsis);
        }
      }
    }
  }

  calculateFakeWidth(text) {
    const tempDiv = document.createElement('div');
    document.body.appendChild(tempDiv);
    tempDiv.style.fontSize = '17px';
    tempDiv.style.position = 'absolute';
    tempDiv.style.left = -1000;
    tempDiv.style.top = -1000;
    tempDiv.style['white-space'] = 'nowrap';
    tempDiv.style.lineHeight = '32px';
    tempDiv.innerHTML = text;
    const width = tempDiv.clientWidth;
    document.body.removeChild(tempDiv);
    return width;
  }

  dropdownChangeHandler(value) {
    const {
      reflectionSummary: {
        dropDownObject,
      },
    } = this.props.skills;
    const draft = dropDownObject[value];
    if (draft) {
      this.props.onTabChange(`reports/type/reflections/${draft.id}`);
    }
  }

  buttonClickHandler() {
    this.setState({
      buttonText: this.state.studentListCollapsed ? 'Show All Students' : 'Show Fewer Students',
      studentListCollapsed: !this.state.studentListCollapsed,
    });
  }

  render() {
    const {
      reflectionSummary: {
        error: errorReflectionsSummary,
        loading: loadingReflectionsSummary,
        activeDraft,
        allStudents,
        dropDownObject,
      },
      reflectionTrends: {
        error: errorReflectionTrends,
        loading: loadingReflectionTrends,
        trends,
      },
    } = this.props.skills;
    const breadcrumbItems = [
      { text: 'Overview', targetUrl: 'reports' },
      { text: this.props.reportTitle }];

    if (loadingReflectionsSummary || loadingReflectionTrends) return <Spinner className={s.reflectionSpinner} />;
    if (errorReflectionsSummary || errorReflectionTrends) return <ReportError />;
    const hasAgree = allStudents && activeDraft ? _.filter(allStudents[activeDraft.id], student => student.questionResponseSortingValue > 3) : [];
    return (
      <div className={s.reportContainer} ref={this.containerRef}>
        <h1 className={s.title}>Reflection Snapshot: I understand the criteria that will be used to provide me feedback.</h1>
        <ReportBreadcrumbs
          items={breadcrumbItems}
          onTabChange={this.props.onTabChange}
        />
        {
          (allStudents && activeDraft && dropDownObject && dropDownObject.length !== 0 && allStudents[activeDraft.id]) &&

          <Card className={s.ReflectionCard}>
            <Media query="(max-width: 709px)">
              <SkillsReflectionDropdown
                dropDownObject={dropDownObject}
                activeDropdown={activeDraft}
                dropdownChangeHandler={this.dropdownChangeHandler}
              />
            </Media>
            <SkillsReflectionTable
              displayedStudentList={allStudents[activeDraft.id]}
              tableStyle={this.state.tableStyle}
              collapse={this.state.studentListCollapsed}
            />

            {((hasAgree.length > 0 && allStudents[activeDraft.id].length !== hasAgree.length) || (hasAgree.length === 0 && allStudents[activeDraft.id].length > 5)) &&
              <div className={s.buttonContainer}>
                <Button className={s.showAllButton} theme="secondary" onClick={this.buttonClickHandler}>
                  {
                    this.state.studentListCollapsed ? 'Show All Students' : 'Show Fewer Students'
                  }
                </Button>
              </div>
            }
          </Card>
        }
        {trends && <StackedBarReflection drafts={trends} />}
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    skills: state.reports.skills,
    courseName: state.reports.courseAbstract.shortName,
    reportTitle: state.reports.skills.reflectionSummary.reportTitle,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchReflectionSummaryReportData: bindActionCreators(fetchReflectionSummaryReportData, dispatch),
    updateActiveDraftReflectionSummary: bindActionCreators(updateActiveDraftReflectionSummary, dispatch),
  };
}

const ConnectedSkillsReflectionSummary = connect(mapStateToProps, mapDispatchToProps)(SkillsReflectionSummary);
export default withMatch(ConnectedSkillsReflectionSummary);
